module.exports = __webpack_public_path__ + "img/kpxjt_left_unselect.1c328803.png";